import { render, staticRenderFns } from "./IsciAlacakForm.vue?vue&type=template&id=f9609536"
import script from "./IsciAlacakForm.vue?vue&type=script&lang=ts"
export * from "./IsciAlacakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports